// src/pages/LiveCricketPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../utils/api'; // Your Axios instance
import './LiveCricketPage.css';

const LiveCricketPage = () => {
    const navigate = useNavigate();
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch Data
    const fetchScores = async () => {
        try {
            const response = await apiClient.get('/cricket-scores');
            setMatches(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching scores", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchScores();
        // Auto-refresh every 30 seconds
        const interval = setInterval(fetchScores, 30000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="cricket-page-container">
            <div className="cricket-header">
                <button className="back-btn" onClick={() => navigate('/')}>← Back</button>
                <h1>🏏 Match Center</h1>
                <button className="refresh-btn" onClick={fetchScores}>↻</button>
            </div>

            <div className="cricket-content">
                {loading ? (
                    <div className="loading-spinner">Loading Scores...</div>
                ) : matches.length === 0 ? (
                    <div className="no-matches">No matches found.</div>
                ) : (
                    matches.map((match) => (
                        <div key={match.id} className="match-card">
                            
                            {/* 1. HEADER: Series Name & Type */}
                            <div className="match-info">
                                {/* Shows "India vs South Africa" instead of "CFC365..." */}
                                <span className="series-name">{match.title}</span>
                                
                                <div className="match-badges">
                                    <span className="match-type">{match.matchType}</span>
                                    {match.isLive && <span className="live-badge">LIVE</span>}
                                </div>
                            </div>

                            {/* 2. TEAMS & SCORES */}
                            <div className="teams-score-container">
                                {/* Team 1 */}
                                <div className="team-block">
                                    {match.t1Img && <img src={match.t1Img} alt={match.t1} className="team-logo" />}
                                    <div className="team-name">{match.t1}</div>
                                    <div className="team-score">{match.t1Score || "-"}</div>
                                </div>

                                <div className="vs-divider">VS</div>

                                {/* Team 2 */}
                                <div className="team-block">
                                    {match.t2Img && <img src={match.t2Img} alt={match.t2} className="team-logo" />}
                                    <div className="team-name">{match.t2}</div>
                                    <div className="team-score">{match.t2Score || "-"}</div>
                                </div>
                            </div>

                            {/* 3. STATUS & VENUE */}
                            <div className="match-status" style={{color: match.isLive ? '#d32f2f' : '#666'}}>
                                {match.status}
                            </div>
                            <div className="match-venue">
                                📍 {match.venue}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default LiveCricketPage;